'use client'

import CTA from './cta'
import { HomepageSearch } from './homepage-search'

export function HomepageV1() {
  return (
    <div className='flex flex-col items-center justify-center min-h-[60vh] w-full px-6 py-12 gap-8'>
      <h1 className='text-center text-primary text-4xl sm:text-5xl font-extralight font-serif'>
        Free your finance.
      </h1>
      <HomepageSearch />
      <CTA />
    </div>
  )
}
